var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.wrapper, ( _obj = {}, _obj[_vm.$style.locked] = _vm.locked, _obj[_vm.$style.active] = _vm.active, _obj )],on:{"click":function () { _vm.active && _vm.$emit('click')}}},[_c('div',{class:_vm.$style.icon,style:({ backgroundImage: ("url(" + _vm.image + ")")})})])}
var staticRenderFns = []

export { render, staticRenderFns }